import { message } from 'antd'

const notificationRequest = (
  status: number,
  action?: 'get' | 'mutate',
  successMessage?: string,
  failMessage?: string
) => {
  if (status >= 200 && status < 300) {
    if (action === 'mutate') {
      message.success(successMessage || 'Hành động thành công')
    } else if (successMessage) {
      message.success(successMessage)
    }
  }
  if (status >= 300 && status < 500) {
    message.error(failMessage || `Dữ liệu không đúng hoặc không tồn tại`)
  }
  if (status >= 500) {
    message.error('Hành động thất bại')
  }
}

export default notificationRequest
